import { render, staticRenderFns } from "./AddCard.vue?vue&type=template&id=f0f3f8d0"
import script from "./AddCard.vue?vue&type=script&lang=js"
export * from "./AddCard.vue?vue&type=script&lang=js"
import style0 from "./AddCard.vue?vue&type=style&index=0&id=f0f3f8d0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports